class PageAnimate {
    constructor() {
        $('[data-animate]').each((i, e) => {
            this.initAnimate(e)
        });

        if ($('[data-animate-onscroll]').length > 0) {
            this.scrollAnimate();
            $(window).on('scroll', () => {
                this.scrollAnimate()
            });
        }
    }

    initAnimate(e) {
        let animateClass = $(e).data('animate');
        let animateDelay = $(e).data('animateDelay') || 300;
        setTimeout(() => {
            $(e).addClass(animateClass + ' animated');
        }, animateDelay)
    }

    scrollAnimate() {
        $('[data-animate-onscroll]').each((i, e) => {
            let animatePos = ($(window).scrollTop() + $(window).height());
            let elementOffsetTop = $(e).offset().top;
            if (animatePos >= elementOffsetTop) {
                setTimeout(() => $(e).addClass($(e).data('animateOnscroll')), 300);
            } else {
                $(e).removeClass($(e).data('animateOnscroll'));
            }
        });

        $('.zoom-image').each((i, e) => {
            let animatePos = ($(window).scrollTop() + $(window).height());
            let elementOffsetTop = $(e).offset().top;
            if (animatePos >= elementOffsetTop) {
                setTimeout(() => $(e).addClass('_animate'), 300);
            } else {
                $(e).removeClass('_animate');
            }
        });
    }
}

export default PageAnimate;
